import { useNavigate } from 'react-router-dom';

export const BannerEssentials = () => {
  const navigate = useNavigate();
  return (
    <div className="container-banner-essentials-home-page">
      <h1>DISCOVER OUR&nbsp;ESSENTIALS</h1>
      <p>
        These are the pieces that stay with you. Designed for comfort, built for
        performance, and refined in every stitch.
      </p>
      <div className="wrapper-essentials-home-page">
        <div
          className="image-button-container"
          onClick={() => navigate('/essentials/men')}
        >
          <img
            src="images/essentials/essentials_men.webp"
            alt="Essentials Men"
            className="banner_essentials_home_page"
          />
          <button className="btn-read-more-essentials-men">
            MEN'S ESSENTIALS
          </button>
        </div>
        <div
          className="image-button-container"
          onClick={() => navigate('/essentials/women')}
        >
          <img
            src="images/essentials/essentials-women.webp"
            alt="Essentials Women"
            className="banner_essentials_home_page"
          />
          <button className="btn-read-more-essentials-men">
            WOMEN'S ESSENTIALS
          </button>
        </div>
      </div>
    </div>
  );
};
